import React from 'react'
import { FiCheck } from 'react-icons/fi'
import { connect } from 'react-redux'
import { formValues } from 'redux-form'
import { withTranslation } from 'react-i18next'
import { IStore } from '../../../reducers'
import styled, { theme } from '../../../theme'
import StatusColor from '../../Calendar/BookingCalendar/EventHint/StatusColor'
import { getCalendarPreferences } from '../../../reducers/userObject/selectors/settings'
import { labels } from '../../../models/Event/eventConfig'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const StatusWrapper = styled.div<{ color: string } & IWithSize>`
  width: 100%;
  height: ${({ size }) => (size ? 44 * size : 44)}px;

  display: flex;
  background-color: ${props => props.color};
  align-items: center;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  letter-spacing: 0.1px;
  cursor: pointer;
`

function RadioInputWrapper({ label, color, checked, size = 1, cy }) {
  return (
    <StatusWrapper
      data-cy={cy}
      size={size}
      color={checked && theme.colors.palette.paleGrey}
    >
      <StatusColor size={size} color={color}>
        {checked && <FiCheck />}
      </StatusColor>
      <div style={{ wordBreak: 'break-all' }}>{label}</div>
    </StatusWrapper>
  )
}

const RadioInput:any = connect((state: IStore) => ({
  status: getCalendarPreferences(state),
}))(
  formValues<any>('reservationStatus')(
    withTranslation()(
      ({
        t,
        status,
        size = 1,
        customStatus,
        reservationStatus,
        eventStatus,
        prepaidType,
        cy,
      }: any) => {
        return (
          <RadioInputWrapper
            cy={cy}
            size={size}
            label={
              customStatus
                ? customStatus.labels[eventStatus] ||
                  t(
                    labels.get(
                      prepaidType !== null
                        ? Number(prepaidType) === 1
                          ? eventStatus
                          : '3-2'
                        : eventStatus,
                    ),
                  )
                : status.labels[eventStatus] ||
                  t(
                    labels.get(
                      prepaidType !== null
                        ? Number(prepaidType) === 1
                          ? eventStatus
                          : '3-2'
                        : eventStatus,
                    ),
                  )
            }
            color={
              customStatus
                ? customStatus.colors[eventStatus].rgb().toString()
                : status.colors[eventStatus].rgb().toString()
            }
            checked={reservationStatus === eventStatus}
          />
        )
      },
    ),
  ),
)

export default function(
  status,
  customStatus,
  prepaidType = null,
  size = 1,
  cy,
) {
  return function() {
    return (
      <RadioInput
        cy={cy}
        eventStatus={status}
        size={size}
        customStatus={customStatus}
        prepaidType={prepaidType}
      />
    )
  }
}
